import { Component, OnInit } from '@angular/core';
import { ForgotPasswordService } from './forgot-password.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from '../../../management/components/tabs/components/users/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import { POSTHOG_EVENT_FORGOT_PASSWORD } from 'src/app/shared/constants/posthog-events.constants';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
	blockLoader = "blockLoader";
	email: string = "";

	constructor(
		private usersService: UsersService,
		private snackbar: MatSnackBar,
		private forgotPasswordService: ForgotPasswordService,
		private spinner: NgxSpinnerService,
		private posthog: PostHogService
	) { }

	ngOnInit() { }

	async getResetEmail() {
		await this.spinner.show("blockLoader");
		const doesUserExist = await this.usersService.checkIfUserExists(this.email);
		await this.spinner.hide("blockLoader");

		if (!doesUserExist) {
			this.snackbar.open("This email is not registered with us.", "OK", {
				duration: 3000
			});
		} else {
			await this.spinner.show("blockLoader");
			const hasRequested = await this.forgotPasswordService.hasRequestedEmail(this.email);
			// console.log(hasRequested);
			await this.spinner.hide("blockLoader");

			if (hasRequested) {
				this.snackbar.open("You can receive only one email for password email in 30 minutes.", "OK", {
					duration: 3000
				});
			} else {
				await this.spinner.show("blockLoader");
				await this.forgotPasswordService.getResetEmail(this.email);
				await this.spinner.hide("blockLoader");
				this.snackbar.open("A password reset email has been sent to your email address", "OK", {
					duration: 3000
				});

				this.posthog.capture(POSTHOG_EVENT_FORGOT_PASSWORD, {
					login_method: 'Email',
					email: this.email,
					session_id: this.posthog.getSessionId()
				});
			}
		}
	}
}
